export const NEXT_ITEM = "NEXT_ITEM";
export const PREV_ITEM = "PREV_ITEM";
